import './styles.css'
const ProductButton = () => {
    return (
        <button className='btn btn-primary btn-style'>
            <h6>COMPRAR</h6>
        </button>
    );
}

export default ProductButton;